// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31Psq","toggle":"styles_toggle__10TEL","preview":"styles_preview__3a87R"};